import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStage } from '../Provider';
import { StyledStageHeader } from './StagePanel.styles';
import { BlockEvents } from './components/BlockEvents';
import { StatusTag } from './components/StatusTag';
import { useStageTimer } from '../../hooks/use-stage-timer';

export const StageHeader = observer(() => {
    const { t } = useTranslation();
    const { name, blocks, id, isDisabled } = useStage();

    const stageRef = useRef<HTMLDivElement>(null);
    const [searchParams] = useSearchParams();
    useStageTimer();
    useEffect(() => {
        if (stageRef.current && searchParams.get('stage') === id.toString()) {
            stageRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);
    return (
        <StyledStageHeader ref={stageRef} $isDisabled={isDisabled}>
            <div className="stage-name-and-block-events-container">
                <div className="stage-name">{t(name)}</div>
                {!!blocks?.length && <BlockEvents/>}
            </div>
            <StatusTag/>
        </StyledStageHeader>
    )
});
